<template>
    <div class="login">
        <div class="p-d-flex p-jc-center">
            <Card>
                <template #title>
                  <h5 class="p-text-center">Harborwall Management</h5>
                </template>
                <template #content>
                  <form class="p-fluid">
                      <div class="p-field">
                          <div class="p-float-label">
                              <InputText id="username" v-model="user.username" />
                              <label for="username">Username*</label>
                          </div>
                      </div>
                      <div class="p-field">
                          <div class="p-float-label">
                              <InputText id="password" type="password" v-model="user.password" v-on:keyup.enter="handleLogin" toggleMask />
                              <label for="password">Password*</label>
                          </div>
                      </div>
                      <!--
                      <div class="p-field-checkbox">
                          <Checkbox id="rememberme" :binary="true" v-model="remember_me"></Checkbox>
                          <label for="rememberme">Remember me</label>
                      </div>
                      -->
                      <div class="p-mb-3" v-if="errors.fatal">
                        <small class="p-error p-pb-4" v-if="errors.fatal">{{ errors.fatal }}</small>
                      </div>
                      <Button label="Sign In" icon="pi pi-user" class="w-full" @click="handleLogin"></Button>
                  </form>
                </template>
            </Card>
        </div>
        <Dialog v-model:visible="show2faChallenge" :breakpoints="{ '960px': '80vw' }" :style="{ width: '30vw' }" position="top">
            <div class="p-d-flex p-ai-center p-dir-col p-pt-3 p-px-3">
                <h5>Enter 2FA Code</h5>
                <p :style="{lineHeight: 1.5, textIndent: '1rem'}">
                    <InputText type="text" v-model="mfaCode" class="p-inputtext-lg"  placeholder="Code" v-on:keyup.enter="verify2fa" autofocus />
                </p>
                <p class="p-error" v-if="errors.totp">{{ errors.totp }}</p>
            </div>
            <template #footer>
                <div class="p-d-flex p-jc-center">
                    <Button label="Verify" @click="verify2fa" />
                </div>
            </template>
        </Dialog>

    </div>
</template>

<script>
//import { mapActions } from 'vuex'
export default {
  name: 'Login',
  components: {},
  data () {
    return {
      user: {
        username: '',
        password: ''
      },
      remember_me: false,
      showError: false,
      showMessage: false,
      errors: {},
      ident: '',
      show2faChallenge: false,
      mfaCode: ''
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      //this.$router.push("/profile");
    }
  },
  methods: {
    handleLogin() {
      this.loading = true;
      this.$store.dispatch("auth/login", this.user)
        .then(response => {

          if (response.challenge && response.challenge == 'totp') {
            // show TOTP
            this.show2faChallenge = true
            this.ident = response.identifier
          }
          else {
            this.$router.push("/");
            //window.location.href="/";
          }
        },
        (error) => {
          this.loading = false;

          this.errors = error.response.data.errors[0]

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    verify2fa() {
      this.loading = true;

      let data = {"identifier": this.ident, "code": this.mfaCode}

      this.$store.dispatch("auth/verifyTOTP", data)
        .then(response => {
          this.$router.push("/")
          //window.location.href="/";
        })
        .catch(error => {
          this.errors = error.response.data.errors[0]
        })
        .finally(() => this.loading = false)
    },


  },
}
</script>

<style lang="scss" scoped>
.login {
    .p-card {
        min-width: 350px;

        form {
            margin-top: 2rem;
        }

        .p-field {
            margin-bottom: 1.5rem;
        }
    }

    @media screen and (max-width: 960px) {
        .card {
            width: 80%;
        }
    }
}
</style>
